<template>
  <div id="password">
    <div class="inner">
      <el-row class="title">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark g-title">修改密码</div>
        </el-col>
      </el-row>
      <el-form
        :model="ruleForm2"
        status-icon
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="passfrom"
      >
        <el-form-item label="旧密码" prop="oldpass">
          <el-input v-model="ruleForm2.oldpass" type="password" placeholder='请输入当前密码'></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input v-model="ruleForm2.pass" type="password" placeholder='请输入新密码(密码不少于6个字符)'></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="ruleForm2.checkPass" type="password" placeholder='请再次输入密码'></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="qd" type="primary" @click="submitForm('ruleForm2')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var oldpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      }else{
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }else if(value.length <6 || value.length>12){
        callback(new Error("密码长度只能为6-12位"));
      }else if(/[^\x00-\xff]+$/.test(value)){
        callback(new Error('不能使用汉字或全角字符作为密码'));
      }else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        pass: "",
        checkPass: "",
        oldpass: ""
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        oldpass: [{ validator: oldpass, trigger: "blur" }]
      }
    };
  },
  watch:{
    ruleForm2:{
      deep:true,
      handler:function(newVal,oldVal){
        this.ruleForm2.pass = this.ruleForm2.pass.replace(/\s+/g,'');
        this.ruleForm2.checkPass = this.ruleForm2.checkPass.replace(/\s+/g,'');
        this.ruleForm2.oldpass = this.ruleForm2.oldpass.replace(/\s+/g,'');
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //修改密码
          this.$api.get('user/updatepwd',{
             id_example:this.$store.state.id_example,
             token_user:this.$store.state.user_id,
             opassword:this.ruleForm2.oldpass,
             password:this.ruleForm2.pass,
             repassword:this.ruleForm2.checkPass,
           },res=>{
             if(res.data.code==100){
               this.$alert(res.data.data, res.data.message, {
                  confirmButtonText: '确定',
                  callback: action => {
                }
                });
             }else{
               this.$message({
                  message: res.data.message,
                  duration: 1500,
                  center: true
                });
             }
           })
        } else {
          return false;
        }
      });

    },
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label{
padding-right: 25px !important;
}
 /deep/.el-form-item{
   margin-bottom: 22px;
 }
 /deep/.el-input__inner{
   height: 52px;
background: #FAFAFA;
border: 1px solid #D6DEE9;
color:#262626;
        &:hover{
        border:solid 1px #b8bfc9;
      }
 }
.qd{
 width: 100% !important;
height: 48px !important;
transition: all 0.5s !important;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;
transition: all 0.5s !important;
}
.qd{
  border: 1px solid #E23130 !important;
}
 .g-title{
    height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;
border-bottom: dashed 1px rgba(151,151,151,0.5);
padding-bottom: 8px;
  }
#password {
  width: 985px;
  min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
    .inputbox {
      // margin: 40px;
      width: 240px;
      height: 38px;
      border: 1px solid rgba(230, 231, 231, 1);
      padding: 0 15px;
      box-sizing: border-box;
      input {
        width: 100%;
        line-height: 34px;
        border: none;
      }
    }
    button {
      width: 109px;
      height: 36px;
      text-align: center;
    }
    .passfrom{
        width: 400px;
        margin: 0 auto;
        margin-top: 60px;
    }
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    margin-top: 55px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 240px;
    }
    .name3 {
      width: 270px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/password.vue